__turbopack_context__.v({
  "actionsStack": "ClientRegisterPage-module__uuxIeG__actionsStack",
  "brandPanelFix": "ClientRegisterPage-module__uuxIeG__brandPanelFix",
  "denseBtn": "ClientRegisterPage-module__uuxIeG__denseBtn",
  "fieldHelp": "ClientRegisterPage-module__uuxIeG__fieldHelp",
  "formFootnote": "ClientRegisterPage-module__uuxIeG__formFootnote",
  "formHeader": "ClientRegisterPage-module__uuxIeG__formHeader",
  "formSideScroll": "ClientRegisterPage-module__uuxIeG__formSideScroll",
  "intentChip": "ClientRegisterPage-module__uuxIeG__intentChip",
  "legalLink": "ClientRegisterPage-module__uuxIeG__legalLink",
  "nameGrid": "ClientRegisterPage-module__uuxIeG__nameGrid",
  "strengthBar": "ClientRegisterPage-module__uuxIeG__strengthBar",
  "strengthBarOn": "ClientRegisterPage-module__uuxIeG__strengthBarOn",
  "strengthBars": "ClientRegisterPage-module__uuxIeG__strengthBars",
  "strengthHeader": "ClientRegisterPage-module__uuxIeG__strengthHeader",
  "strengthLabel": "ClientRegisterPage-module__uuxIeG__strengthLabel",
  "strengthPanel": "ClientRegisterPage-module__uuxIeG__strengthPanel",
  "strengthTone": "ClientRegisterPage-module__uuxIeG__strengthTone",
  "strengthValue": "ClientRegisterPage-module__uuxIeG__strengthValue",
  "successAlert": "ClientRegisterPage-module__uuxIeG__successAlert",
  "tone_danger": "ClientRegisterPage-module__uuxIeG__tone_danger",
  "tone_info": "ClientRegisterPage-module__uuxIeG__tone_info",
  "tone_muted": "ClientRegisterPage-module__uuxIeG__tone_muted",
  "tone_success": "ClientRegisterPage-module__uuxIeG__tone_success",
  "tone_warn": "ClientRegisterPage-module__uuxIeG__tone_warn",
});
